export const SYSTEM_ERROR = {
  UNKNOWN: 'システムで問題が発生しました。時間をおいて再度お試しください。',
  TIMEOUT: '接続がタイムアウトしました。時間をおいて再度お試しください。'
}

export const MOBILE_BREAKPOINT = 1024
